import LoginFailed from './LoginFailed';

export default LoginFailed;
